import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class ProcessButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  checkDetailErrors(detail = []) {
    return detail.some((claim) => claim.acceptanceStatus === null || claim.acceptanceReason === null);
  }

  handleClick() {
    const {returnOrder, detail} = this.props;

    if (this.checkDetailErrors(detail)) {
      this.props.addMessageBoxWarning(
        'Se deben contestar todas las solicitudes del detalle para procesar la devolución.'
      );
      return;
    }

    this.props.processPartsReturnOrder(returnOrder.code, detail, 'process');
  }

  render() {
    const {isUserFromTDE, returnOrder, detail, processing} = this.props;

    if (!isUserFromTDE || !returnOrder || returnOrder.status !== 'E') {
      return null;
    }

    return (
      <Button primary
        content='PROCESAR'
        disabled={processing || !detail.length}
        onClick={this.handleClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'processing': state.partsReturnsOrders.processing,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
    'detail': state.partsReturnsOrders.orderDetail,
  };
};

const {
  addMessageBoxWarning,
  processPartsReturnOrder,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxWarning,
  processPartsReturnOrder,
})(ProcessButton);
